import React from 'react';
import { RouteFetcherContext } from '@mk-redbox/route-fetcher';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static contextType = RouteFetcherContext;

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    const backendRoutes = this.context;
    let requestHistory = JSON.parse(localStorage.getItem('requestHistory'));
    requestHistory.push({ error, errorInfo });
    let stringBody = JSON.stringify(requestHistory);
    fetch(backendRoutes.ClientError, {
      credentials: 'include',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ Payload: stringBody })
    });
    localStorage.setItem('requestHistory', JSON.stringify([]));
  }

  render() {
    if (this.state.hasError) return <h2>Something terrible happened.</h2>

    return this.props.children;
  }
}

export default ErrorBoundary;
